// extracted by mini-css-extract-plugin
export default {"roles-wrapper":"RoleManagement_roles-wrapper__at74H"};